import { Vue, Component, Watch } from "vue-property-decorator";
import { getOrgApis, IOrgApiState } from "@/models/org";
import { OrgModule } from "@/store";
import plusIconBlack from "@/assets/img/plus-icon.svg";
import styles from "./OrgApiDashboard.view.module.scss";
import * as tsx from "vue-tsx-support";
import {
  BContainer,
  BSpinner,
  BCardGroup,
  BCard,
  BCardText,
} from "@/lib/typed-bootstrap";

@Component({})
export default class Dashboard extends Vue {
  _tsx!: tsx.DeclareProps<{}> & tsx.DeclareOnEvents<{}>;

  apis: IOrgApiState[] = [];
  isLoading = false;

  plusIconSrc = plusIconBlack;

  get orgId() {
    return OrgModule.id;
  }

  get workspaceName() {
    return OrgModule.name ?? "Your Workspace";
  }

  @Watch("orgId", { immediate: true })
  async onOrgChange() {
    if (!OrgModule.id) return;
    this.isLoading = true;
    try {
      this.apis = await getOrgApis(OrgModule.id);
    } catch (err) {
      console.log(err);
    } finally {
      this.isLoading = false;
    }
  }

  getApiStateClass(state: string | null | undefined): string {
    switch (state) {
      case "INITIALIZED":
        return "init";
      case "PUBLISHING_FAILED":
        return "failed";
      case "PUBLISHED":
        return "live";
      default:
        return "";
    }
  }

  render() {
    const title = this.$t("org_api_dashboard_title", {
      workspace: this.workspaceName,
    }).toString();

    return (
      <BContainer class="default__view-setup">
        <div class="default__section-header">{title}</div>
        <div class="default__section-subheader">
          {this.$t("org_api_dashboard_subtitle").toString()}
        </div>
        {this.isLoading ? (
          <div class="d-flex default__spinner" role="status">
            <BSpinner type="grow" label="Loading..." variant="light" />
          </div>
        ) : (
          <div style={{ marginTop: "40px" }}>
            <BCardGroup deck>
              <BCard
                bodyClass={`widget__body ${styles.container}`}
                class="col-lg-3 col-md-3 col-xs-2 p-1 grow"
              >
                <router-link
                  class="widget__button--shallow"
                  to={{ name: "project-setup-name" }}
                  data-testid="create-api"
                >
                  <img
                    src={this.plusIconSrc}
                    width="40px"
                    height="40px"
                    alt="Create API"
                  />
                  <BCardText class={styles.text}>
                    {this.$t("org_api_dashboard_cta").toString()}
                  </BCardText>
                </router-link>
              </BCard>
              {this.apis.map((api) => (
                <BCard
                  key={api.id}
                  bodyClass="widget__body api__widget-body__size"
                  class="col-lg-3 col-md-3 col-xs-2 p-1 grow"
                >
                  <router-link
                    class="api__widget-button--shallow"
                    to={{ name: "project-overview", params: { apiId: api.id } }}
                  >
                    <div class="api__widget-padding">
                      <BCardText class="api-summary__name">
                        {api.name}
                      </BCardText>
                      <div>
                        <span
                          class={[
                            "api-publishing-status",
                            this.getApiStateClass(api.state),
                          ].join(" ")}
                        >
                          {this.$t(`api_status.${api.state}`).toString()}
                        </span>
                      </div>
                      <div class="api-summary__headline mt-4">
                        {this.$t("global_region").toString()}
                      </div>
                      <div class="api-summary__value">
                        {this.$t(`aws_region.${api.region}`).toString()}
                      </div>
                      <div class="api-summary__headline">
                        {this.$t("global_auth").toString()}
                      </div>
                      <div class="api-summary__value">
                        {this.$t(`auth_mode.${api.defaultAuthMode}`).toString()}
                      </div>
                    </div>
                  </router-link>
                </BCard>
              ))}
            </BCardGroup>
          </div>
        )}
      </BContainer>
    );
  }
}
